import {PayloadDescriptor} from "@youfoundation/js-lib/dist/core/DriveData/File/DriveFileTypes";

export const getTotalPayloadSize = (payloads: PayloadDescriptor[]): number => {
    return payloads.reduce((p, descriptor) => p + descriptor.bytesWritten, 0);
};